module.exports = __webpack_public_path__ + "static/webCoupon-f85e562ded64a54c70465aeec4ca3844.png";